export default "__VITE_ASSET__C_rmVZK0__"